// This file automatically generated by skymarshal.
// DO NOT MODIFY BY HAND!!!!
//
// From Source File: vehicle/planner/lcmtypes/movement.lcm

import { double } from "@skydio/lcm/src/types";
import { Vector3d } from "../eigen_lcm/Vector3d";
import { uuid_t } from "../uuid_util/uuid_t";

import Long from "long";
import Decoder from "@skydio/lcm/src/decoder";
import Encoder from "@skydio/lcm/src/encoder";
import LcmMsg from "@skydio/lcm/src/lcm";
import ReflectionMeta from "@skydio/lcm/src/reflection";

export class movement_waypoint_t extends LcmMsg {

  private static _hash = Long.fromString("14196794424267506008", true);
  private static _packed_fingerprint?: Long;

  /** @internal */
  public static override _get_packed_fingerprint(): Long {
    if (movement_waypoint_t._packed_fingerprint === undefined) {
      movement_waypoint_t._packed_fingerprint = movement_waypoint_t._get_hash_recursive([]);
    }
    return movement_waypoint_t._packed_fingerprint;
  }

  /** @internal */
  public static override _get_hash_recursive(parents: any[]): Long {
    if (parents.indexOf(movement_waypoint_t) > -1) {
      return Long.fromNumber(0, true);
    }
    const new_parents = parents.concat([movement_waypoint_t]);
    let tmp_hash = movement_waypoint_t._hash;
    tmp_hash = tmp_hash.add(Vector3d._get_hash_recursive(new_parents));
    tmp_hash = tmp_hash.add(uuid_t._get_hash_recursive(new_parents));
    return tmp_hash.shl(1).add(tmp_hash.shru(63));
  }

  /** @internal */
  public static override _reflection_meta: ReflectionMeta = {
    speed: { kind: "primitive", type: Number, typeStr: "double" },
    max_path_speed: { kind: "primitive", type: Number, typeStr: "double" },
    position: { kind: "struct", type: Vector3d, typeStr: "Vector3d" },
    uuid: { kind: "struct", type: uuid_t, typeStr: "uuid_t" },
  };

  public speed: double;
  public max_path_speed: double;
  public position: Vector3d;
  public uuid: uuid_t;

  public override decode(byte_array: Uint8Array): movement_waypoint_t {
    const decoder = new Decoder(new DataView(
      byte_array.buffer, byte_array.byteOffset, byte_array.byteLength
    ));
    const hash = decoder.decode_hash();
    if (!hash.equals(movement_waypoint_t._get_packed_fingerprint())) {
      console.error("Hash mismatch", hash, movement_waypoint_t._get_packed_fingerprint());
      throw new Error("Hash mismatch!");
    }
    this.decode_one(decoder);
    return this;
  }

  public override decode_one(decoder: Decoder): movement_waypoint_t {
    this.speed = decoder.decode_double();
    this.max_path_speed = decoder.decode_double();
    this.position = new Vector3d().decode_one(decoder);
    this.uuid = new uuid_t().decode_one(decoder);
    return this;
  }

  /** @internal */
  public _get_encoded_size(): number {
    let total_size = 0;
    total_size += 8;
    total_size += 8;
    total_size += this.position._get_encoded_size();
    total_size += this.uuid._get_encoded_size();
    return total_size;
  }

  public override encode(): ArrayBufferLike {
    const encoder = new Encoder(8 + this._get_encoded_size()); // hash + rest
    encoder.encode_hash(movement_waypoint_t._get_packed_fingerprint());
    this.encode_one(encoder);

    return encoder.view.buffer;
  }

  public override encode_one(encoder: Encoder): void {
    encoder.encode_double(this.speed);
    encoder.encode_double(this.max_path_speed);
    this.position.encode_one(encoder);
    this.uuid.encode_one(encoder);
  }

  constructor(init?: {speed?: double, max_path_speed?: double, position?: Vector3d, uuid?: uuid_t }) {
    super();
    this.speed = 0.0;
    this.max_path_speed = 0.0;
    this.position = new Vector3d();
    this.uuid = new uuid_t();

    // optionally override default values
    if (!init) {
      return;
    }
    this.speed = init.speed || this.speed;
    this.max_path_speed = init.max_path_speed || this.max_path_speed;
    this.position = init.position || this.position;
    this.uuid = init.uuid || this.uuid;
  }
}